import styled from 'styled-components';
import Blank from '../../atoms/Blank/index';

export default {
	AnswerStyle : styled.span`
		display: inline-block;
		border: 1px dotted gray;
		border-radius: 1em;
		padding:1px;
		position:relative;
		background-color : ${ ({blankColor}) => blankColor ?  blankColor : 'white'};
	`,
	AnswerTextStyle : styled.span`
		visibility:hidden;
	`,
	QuestionNumber : styled.span`
		position:absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
	`,
	ClickableBlank : styled(Blank)`
		cursor : pointer;
	`,
	Blank : Blank,
};